module.exports = __webpack_public_path__ + "static/media/jane_bw.312547b8.png";